import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Section } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Update Course section
 * @param course_id
 * @param version
 * @param section_id
 * @param section
 */
const updateCourseSection = (
  course_id: string,
  version: number,
  section_id: string,
  section: {}
): Promise<Section> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL =
      routes.COURSE + course_id + '/' + version + '/sections/' + section_id
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    AxiosClient.patch(URL, section, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default updateCourseSection
